/**
 * Measures the width of text using canvas context
 * Used for dynamic chart margin calculations
 */
export function measureTextWidth(text: string, fontSize = 12, fontFamily = "system-ui"): number {
  // Check if we're in a browser environment
  if (typeof window === "undefined" || typeof document === "undefined") {
    // SSR fallback: estimate based on character count
    return text.length * (fontSize * 0.6);
  }

  // Create a temporary canvas for text measurement
  const canvas = document.createElement("canvas");
  let context: CanvasRenderingContext2D | null = null;

  try {
    context = canvas.getContext("2d");
  } catch (_e) {
    // Test environment fallback (jsdom doesn't support canvas)
    return text.length * (fontSize * 0.6);
  }

  if (!context) {
    // Fallback: estimate based on character count
    return text.length * (fontSize * 0.6);
  }

  context.font = `${fontSize}px ${fontFamily}`;
  const metrics = context.measureText(text);

  return metrics.width;
}

/**
 * Calculates the maximum width among multiple text strings
 */
export function getMaxTextWidth(texts: string[], fontSize = 12, fontFamily = "system-ui"): number {
  if (texts.length === 0) return 0;
  return Math.max(...texts.map((text) => measureTextWidth(text, fontSize, fontFamily)));
}
